module.exports = __webpack_public_path__ + "static/media/012.11bc298c.jpg";